import { useEffect } from 'react';

interface PageMetaOptions {
  title: string;
  ogTitle: string;
  description: string;
}

const usePageMeta = ({ title, ogTitle, description }: PageMetaOptions) => {
  useEffect(() => {
    document.title = title;

    const metaUpdates: Array<{ selector: string; content: string }> = [
      { selector: 'meta[property="og:title"]',       content: ogTitle },
      { selector: 'meta[name="twitter:title"]',      content: ogTitle },
      { selector: 'meta[name="description"]',        content: description },
      { selector: 'meta[property="og:description"]', content: description },
      { selector: 'meta[property="og:url"]',         content: window.location.href },
    ];

    metaUpdates.forEach(({ selector, content }) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute('content', content);
    });
  }, [title, ogTitle, description]);
};

export default usePageMeta;
